import { Box, Text } from '@betterment/samba-react';
import { Flex } from '@betterment/samba-styled-system/jsx';
import { SambaAutoLink } from '@betterment/shared-components';
import { ListRow } from '@betterment/style-closet-react';

import { GoalIcon } from '../../Shared/components-v2/goal-icon/GoalIcon';
import { urlBuilder } from '../../Shared/urlBuilder';
import { HomeProductOnboardingOptionsQuery } from '../graphql/homeProductOnboardingOptions.generated';

type JointAccountInvitation = HomeProductOnboardingOptionsQuery['checkingReceivedInvitations'][number];

type Props = { invitation: JointAccountInvitation };

export const CheckingReceivedInvitationRow: React.FC<Props> = ({ invitation }) => (
  <ListRow variant="expanded">
    <ListRow.Slot name="leading">
      <Flex flexDirection="row" alignItems="center">
        <Box css={{ width: '36px', marginLeft: 'space.100', marginRight: 'space.150' }}>
          <GoalIcon name="card" />
        </Box>
        <Flex flexDirection="column" justifyContent="center" alignItems="start">
          <Text variant="text100">Joint Checking</Text>
          <Text variant="text50" color="text.weak">
            Invite pending
          </Text>
        </Flex>
      </Flex>
    </ListRow.Slot>
    <ListRow.Slot name="trailing">
      <SambaAutoLink
        variant="solidSecondary"
        spacing="compact"
        to={urlBuilder.appCheckingJointAccountsInvitation.absolute({ jointAccountInvitationId: invitation.id })}
      >
        View invite
      </SambaAutoLink>
    </ListRow.Slot>
  </ListRow>
);
